module.exports = {"id":"177673","name":"Shkëlzen Gashi","rating":"72","photo":"./data/images/photos/3/177673.png","club":{"name":"Colorado Rapids","logo":"./data/images/clubs/ColoradoRapids.png"},"positions":["MG","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShkelzenGashi0.json
// module id = 3941
// module chunks = 0